import { cn } from "@repo/design-system/utils";

interface Props {
  variant: "desktop" | "mobile";
}

export function Logo({ variant }: Props) {
  return (
    <div
      className={cn(
        variant === "desktop" ? "h-10 w-10" : "h-8 w-8",
        "flex flex-shrink-0 items-center justify-center rounded-lg bg-gradient-to-br from-purple-600 to-pink-500"
      )}
    >
      <img
        src="/logo.svg"
        alt="SalonStocker"
        className={cn(variant === "desktop" ? "h-6 w-6" : "h-5 w-5")}
      />
    </div>
  );
}
